export const units = [
  {
    unit: "B",
    name: "Byte",
  },
  {
    unit: "KB",
    name: "Kilobyte",
  },
  {
    unit: "MB",
    name: "Megabyte",
  },
  {
    unit: "GB",
    name: "Gigabyte",
  },
  {
    unit: "TB",
    name: "Terabyte",
  },
  {
    unit: "PB",
    name: "Petabyte",
  },
  {
    unit: "EB",
    name: "Exabyte",
  },
  {
    unit: "ZB",
    name: "Zettabyte",
  },
  {
    unit: "YB",
    name: "Yottabyte",
  },
];

export const expandUnitName = (unit) => {
  for (let i = 0; i < units.length; i++) {
    if (unit === units[i].unit) {
      return units[i].name;
    }
  }
};

export const convertToBytes = (value, unit) => {
  switch (unit) {
    case "B":
      return value;
    case "KB":
      return value * 1000;
    case "MB":
      return value * Math.pow(1000, 2);
    case "GB":
      return value * Math.pow(1000, 3);
    case "TB":
      return value * Math.pow(1000, 4);
    case "PB":
      return value * Math.pow(1000, 5);
    case "EB":
      return value * Math.pow(1000, 6);
    case "ZB":
      return value * Math.pow(1000, 7);
    case "YB":
      return value * Math.pow(1000, 8);
    default:
      console.warn("Unit type not recognised.");
      return value;
  }
};
